export const home = {
  hero: {
    title: 'DR Group GmbH',
    subtitle: 'Beteiligungsholding und Vermögensverwaltung',
    intro: 'Wir halten und verwalten Beteiligungen im eigenen Namen und auf eigene Rechnung. Wir erbringen keine Dienstleistungen für Dritte.',
    viewStructure: 'Struktur ansehen',
    contact: 'Kontakt'
  },
  tiles: {
    investments: {
      title: 'Investments',
      description: 'Strategische Beteiligungen im eigenen Namen'
    },
    assetManagement: {
      title: 'Asset Management',
      description: 'Verwaltung eigenen Vermögens'
    },
    governance: {
      title: 'Governance',
      description: 'Klare Strukturen und Verantwortlichkeiten'
    }
  }
};